import React from 'react'
import FlexDivStyle from './FlexDivStyle/FlexDivStyle'

const FlexDiv = ({children, justify, align}) => (
    <FlexDivStyle justify={justify} align={align}>
        {children}
    </FlexDivStyle>
)

export default FlexDiv